import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { bcEnums } from 'common/common/constants/boldchat-enums';
import { AutoAnswersService } from './auto-answers.service';
import { BcCannedMessagesRepo } from 'common/canned-messages/canned-messages-repo';
import Moment from 'moment';
import { merge } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';
import { WorkItemObservableCacheService } from 'components/work-item-lane-list/work-item-lane/work-item-widget/shared/services/work-item-observable-cache.service';
import { WorkItemTypes } from 'common/workitems/constants/workitem-types';
import { WorkItemChat } from 'common/workitems/models/work-item-chat';

@Component({
  selector: 'app-auto-answers',
  templateUrl: './auto-answers.component.html',
  styleUrls: ['./auto-answers.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class AutoAnswersComponent implements OnInit, OnDestroy {
  @Input() chatId;
  @Input() isActiveChat: boolean;

  public autoAnswers;
  public moment;
  public workItem;

  private mergedObservable;
  private workItemSubscription;
  private questionsObservable;
  private resultsObservable;

  constructor(private autoAnswersService: AutoAnswersService,
              private cannedMessagesRepo: BcCannedMessagesRepo,
              private workItemObservableCacheService: WorkItemObservableCacheService) {

    this.questionsObservable = null;
    this.resultsObservable = null;
    this.autoAnswers = [];
    this.moment = Moment;
  }

  ngOnInit() {
    this.workItemSubscription = this.workItemObservableCacheService.getWorkItemObservable(this.chatId, WorkItemTypes.CHAT)
      .subscribe(chat => this.workItem = new WorkItemChat(chat));

    this.questionsObservable = this.autoAnswersService.createAAQuestionsObservableByChatId(this.chatId);
    this.resultsObservable = this.autoAnswersService.createAAResultsObservableByChatId(this.chatId);

    this.mergedObservable = merge(...[this.questionsObservable, this.resultsObservable]).pipe(
      tap((autoAnswer) => this.setAutoAnswers(autoAnswer)),
      debounceTime(100),
      tap(() => this.sortAutoAnswersByCreated()),
      debounceTime(100)
    )
      .subscribe(() => this.addAutoAnswerFields());
  }

  ngOnDestroy() {
    if (this.mergedObservable && this.mergedObservable.unsubscribe) {
      this.mergedObservable.unsubscribe();
    }

    if (this.workItemSubscription) {
      this.workItemSubscription.unsubscribe();
    }
  }

  setAutoAnswers(autoAnswer) {
    this.autoAnswers.push(autoAnswer);
  }

  sortAutoAnswersByCreated() {
    this.autoAnswers.sort((a, b) => {
      if (a.Created < b.Created) {
        return -1;
      } else if (a.Created === b.Created) {
        return 0;
      }
      return 1;
    });
  }

  addAutoAnswerFields() {
    this.autoAnswers
      .filter(item => item.CannedMessageID)
      .forEach((value) => {
        value.autoAnswerFields = {
          Action: this.getAction(value.Status),
          CannedMsgName: '',
          Vote: this.getVote(value.Status)
        };

        this.getCannedMessageById(value.CannedMessageID)
          .then(cannedMessage => {
            if (cannedMessage && cannedMessage.length > 0) {
              value.autoAnswerFields.CannedMsgName = cannedMessage[0].name;
            }
          });
      });
  }

  getAction(autoAnswerStatus) {
    if (autoAnswerStatus === bcEnums.autoAnswerStatuses.OPENED) {
      return 'autoAnswers.opened';
    }

    return 'autoAnswers.rated';
  }

  getCannedMessageById(cannedMessageId) {
    const replaceVariables = !!this.isActiveChat;
    return this.cannedMessagesRepo.getCannedMessageNameById(this.chatId, this.workItem.ChatWindowDefID, cannedMessageId, replaceVariables);
  }

  getVote(autoAnswerStatus) {
    if (autoAnswerStatus !== bcEnums.autoAnswerStatuses.OPENED) {
      if (autoAnswerStatus === bcEnums.autoAnswerStatuses.POSITIVE) {
        return 'autoAnswers.positive';
      }

      return 'autoAnswers.negative';
    }

    return '';
  }
}
